TS.ns('WL');

WL.reportsExecutionModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this;
        me.parent(config);
    },

    createProperties: function (config) {
        var me = this;
        me.parent(config);
    },

    createCommands: function (config, server) {
        var me = this;
        me.parent(config);

        var cmd = me.getCommand('Navigation.ShowReport');
        if (cmd != null)
            cmd.handler = "_showReport";
    },

    _showReport: function (e) {
        var me = this;
        me.performServerCommand('Navigation.' + e.Code, true, null,
            function (r) {
                var me = this;

                if (r.modelData == undefined)
                    return;

                if (!r.modelData.ReportExportIsHtml)
                    return;

                var url = me.rootUrl + '/../Handlers/GetReport.ashx' + "?ReportId=" + r.modelData.ReportExportId + r.modelData.ReportExportParameters;
                window.open(url, '_blank');
            });
    }

});